import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../../FirebaseConfig";
import { updateDataByID } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

const getParseData = (item) => {
  try {
    return JSON.parse(item);
  } catch (error) {
    console.error("Parsing error:", error);
    return null;
  }
};

const DeleteSubCategory = ({ open, onClose, componentData }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(false);
    }
  }, [open]);

  const handleDeleteSubCategory = async () => {
    setLoading(true);
    try {
      await removeSubCategoryDetail();
      onClose(); 
    } catch (error) {
      console.error("Error deleting sub-category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setLoading(false);
    onClose(); 
  };

  const removeSubCategoryDetail = async () => {
    try {
      let all_items_of_cat = componentData?.category?.items;
      let item = getParseData(all_items_of_cat[componentData?.index]);

      if (item?.l_s_c_d_id?.length > 0) {
        const docIDToDelete = item.l_s_c_d_id.pop();

        const docRef = doc(
          db,
          "library_sidebar_category_details_collection",
          docIDToDelete
        );
        await deleteDoc(docRef);

        if (item.l_s_c_d_id.length === 0) {
          item.isDetailAvailable = false;
          item.isActive = false;
        }
      }

      all_items_of_cat.splice(componentData?.index, 1);

      let new_data_obj = {
        ...componentData?.category,
        items: all_items_of_cat,
      };

      await updateDataByID(
        componentData?.category?.id,
        new_data_obj,
        "library_sidebar_categories_collection",
        (res) => console.log("Item removed successfully", res)
      );
    } catch (error) {
      console.error("Error removing sub-category detail:", error);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
        }}
      >
        {loading ? (
          <LoadingCircular />
        ) : (
          <>
            <DialogTitle>
              Are you sure you want to delete this sub-category?
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCancelDelete} color="primary">
                No
              </Button>
              <Button
                onClick={handleDeleteSubCategory}
                color="secondary"
                autoFocus
              >
                Yes
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};

export default DeleteSubCategory;
